import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ElementRef, HostListener } from '@angular/core';
import { Subscription } from "rxjs";
//import { Role } from '../shared/enums/role.enum';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { DebounceClickDirective } from '../../../../../directives/debounce-click.directive';
import { NtPotentialRegionInterface } from "../../../../shared/interfaces/nt-potential-region.interface";
import { DmtUtilityService } from '../../../../services/dashboard/dmt-utility.service';
import { AuthService } from '../../../../services/auth/auth.service';
import { DataService } from '../../../../services/dashboard/data.service';
import { IsEditStatusTsService } from '../../../../services/dashboard/isEditStatus/is-edit-status.ts.service';

@Component({
  selector: 'app-side-bar',
  imports: [CommonModule, /*DebounceClickDirective,*/ RouterModule],
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.css']
})


export class SideBarComponent implements OnInit {

  statusTerritorialSidebar: number = 0; // 0 = chiusa, 1 = intermedia, 2 = aperta
  offset: number = 0;
  sidebarPosition: { top: number } | null = null;


  @ViewChild('sidebar') sidebar!: ElementRef;


  isProfileDropdownOpen: boolean = false;

  idToNational: number = 0;

  @Input() national = 'true';
  @Input() pageName = "";
  @Output() openFeedbackModal: EventEmitter<boolean> = new EventEmitter<boolean>();

  regioniData: NtPotentialRegionInterface[] = [];

  public regionId = 1;

  public medicineId = 1;

  public countryId = 1;

  public viewRegioni = false;

  public viewBottonUp = false;

  public viewBottonDown = true;

  public viewBottonLeft = false;

  public regionaName = '';

  public nationName: string | null | undefined;

  public sessionLevel: string | null | undefined;

  //private username = '';
  private companyId = '';
  private sessionToken = '';
  //private businessName = '';
  private openToAccessType = '';

  isExpanded = false;
  isActiveModalMedicine = false;

  public username: string = '';

  public fullName: string | undefined = '';

  userInitials: string = '';

  public businessName = '';

  public role = '';

  private subscriptions = new Subscription();

  userAccess: any[] = [];

  //public companyId = 0;


  isActiveModalUserFeedback = false;

  canExpandedConstentShow = false;

  solutionOn: string | null = '';

  isTerritorial: boolean = false;

  animateSidebar = false;


  @Input() isDashboardOpen: boolean = false;
  @Input() inWhichPage: string = "";
  constructor
    (private dataService: DataService,
      private authService: AuthService,
      private router: Router,
      private us: DmtUtilityService,
      private isEditService: IsEditStatusTsService) { }

  ngOnDestroy (): void {
    // destroy listener to able national and regional
    window.removeEventListener('isDashboardOpen', this.dashboardOpen as EventListener);
    window.removeEventListener('inWhichPage', this.whichSolution as EventListener);
  }

  ngOnInit () {
    window.addEventListener('isDashboardOpen', this.dashboardOpen as EventListener);
    window.addEventListener('inWhichPage', this.whichSolution as EventListener);

    let currentSolution = this.inWhichPage;

    // if not available from the inpiut check the sessionStorage
    if (!currentSolution && sessionStorage.getItem('level')) {
      const level = sessionStorage.getItem('level');
      if (level === 'national') {
        currentSolution = 'NATIONAL';
      } else if (level === 'regional') {
        currentSolution = 'REGIONAL';
      } else {
        currentSolution = 'FARMACO';
      }
    }

    // set status of second bar based on the page
    if (currentSolution === "NATIONAL" || currentSolution === "REGIONAL") {
      this.statusTerritorialSidebar = 1;
    } else {
      this.statusTerritorialSidebar = 0;
    }

    this.medicineId = this.us.getSessionVariableNumber('medicineId');
    this.countryId = this.us.getSessionVariableNumber('countryId') //Number(sessionStorage.getItem('medicineId'));
    this.username = sessionStorage.getItem('username') ?? '';


    this.loadData();

    this.dataService.medicineUpdated$.subscribe((medicineId: number) => {
      if (medicineId !== 0) {
        this.medicineId = medicineId;

        this.loadData();  // Ricarica i dati quando cambia il medicineId
      }
    });

    //Get user name and lastname
    const [firstName, lastName] = this.username.split('.').map(name =>
      name ? name.charAt(0).toUpperCase() + name.slice(1).toLowerCase() : ''
    );
    this.fullName = `${firstName} ${lastName || ''}`.trim();
    this.userInitials = this.getInitials(this.fullName);




    //// to remove and change when we have homepage
    /*  this.medicineId = this.us.getSessionVariableNumber('medicineId')
      this.countryId = this.us.getSessionVariableNumber('countryId')*/
    /*
// GET USER
 this.username = sessionStorage.getItem('username') ?? '';

    //Get user Role
    if (this.authService.hasRole(Role.ADMIN)) {
      this.role = 'Amministratore';
    } else if (this.authService.hasRole(Role.OFFICE)) {
      this.role = 'Coordinatore RAM';
    } else {
      this.role = 'Regional Access Manager';
    }*/

  }

  // this is used so after the DOM loads we deactivate the animations for the first time (applied on the template on the second sidebar)
  ngAfterViewInit () {
    setTimeout(() => this.animateSidebar = true, 50);
  }

  /*@HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const clickedInsideSidebar = this.sidebar?.nativeElement.contains(event.target);
  
    if (!clickedInsideSidebar) {
      console.log("CLICCATO FUORI");
    }
  }*/

  loadData () {
    this.dataService.getRegioniData(this.medicineId, this.countryId).subscribe((data: NtPotentialRegionInterface[]) => {
      this.regioniData = data;
    });

    this.authService.refreshUserData();

    /*const userData = this.authService.getUserData();

    this.userAccess = userData?.roles || [];
    const { roleLabel } = this.extractRoleAndRegions(this.userAccess);
    this.role = roleLabel;*/

    if (sessionStorage.getItem('username')) {
      this.username = sessionStorage.getItem('username') ?? '';
    }

    if (sessionStorage.getItem('companyId')) {
      this.companyId = sessionStorage.getItem('companyId') ?? '';
    }

    if (sessionStorage.getItem('access_token')) {
      this.sessionToken = sessionStorage.getItem('access_token') ?? '';
    }

    if (sessionStorage.getItem('businessName')) {
      this.businessName = sessionStorage.getItem('businessName') ?? '';
    }

    if (sessionStorage.getItem('openType')) {
      this.openToAccessType = sessionStorage.getItem('openType') ?? '';
    }

    sessionStorage.setItem('level', 'national');
    sessionStorage.setItem('nationName', 'Italy');
    sessionStorage.setItem('medicineId', String(this.medicineId));
    sessionStorage.setItem('countryId', '1');
    sessionStorage.setItem('username', this.username);
    sessionStorage.setItem('companyId', this.companyId);
    sessionStorage.setItem('access_token', this.sessionToken);
    sessionStorage.setItem('businessName', this.businessName);
    sessionStorage.setItem('openType', this.openToAccessType);
  }


  getInitials (name: string): string {
    const nameParts = name.split(' ');
    const initials = nameParts.map(part => part.charAt(0)).join('').toUpperCase();
    return initials.length > 2 ? initials.substring(0, 2) : initials;
  }

  /*extractRoleAndRegions (access: string[]): { roleCode: string; roleLabel: string; regions: string[] } {
    const roleLabels: Record<string, string> = {
      USERS: 'User',
      SUPERUSER: 'Super User',
      ADMIN: 'Amministratore'
    };

    const roles = ['ADMIN', 'SUPERUSER', 'USERS'];
    const roleCode = access.find(item => roles.includes(item)) || 'USERS';
    const roleLabel = roleLabels[roleCode] || roleCode;
    const regions = access.filter(item => !roles.includes(item));

    return { roleCode, roleLabel, regions };
  }*/



  public showRegioni () {
    this.viewRegioni = true; // Imposta esplicitamente la visualizzazione delle regioni
    this.sessionLevel = sessionStorage.getItem('level');
    this.goToNational("Italy")

  }

  @Output() regionalTrue = new EventEmitter<string>();
  @Output() nationalTrue = new EventEmitter<string>();

  goToRegional (regione: string, regionId: string) {
    //Format region name's spaces to match with user group label
    // let regionFormatted = regione.trim().replace(/\s+/g, '-');

    /* if (!this.authService.isAuthorizedForRegion(regionFormatted)) {
       alert("L'utente non ha i privilegi per accedere alla risorsa");
       return;
     }*/
    this.statusTerritorialSidebar = 1;
    this.sessionLevel = sessionStorage.getItem('level');
    this.regionaName = regione;
    this.regionId = Number(regionId);


    localStorage.setItem("regionName", this.regionaName);
    sessionStorage.setItem('regionId', regionId);
    sessionStorage.setItem('medicineId', this.medicineId.toString());
    sessionStorage.setItem('level', 'regional');
    this.regionalTrue.emit('200 OK');
    this.dataService.getHospitalInfoData(this.medicineId, this.countryId, this.regionId).subscribe((data: any) => {
      /*if (Array.isArray(data) && data.length > 0) {
        sessionStorage.setItem('hospitalOnekey', data[0].onekey);
        sessionStorage.setItem('hospitalName', data[0].name);
      }*/
      this.setHospitalSession(data);
      this.router.navigate(['/dashboard/territorial/regional', this.medicineId, regionId]);
      this.isExpanded = false;
    })
    //   console.log("ONEKEY:",onekey);


  }

  goToNational (nation: string | null) {
    // this.statusTerritorialSidebar=1;
    this.nationName = nation;
    sessionStorage.setItem('level', 'national');
    this.nationalTrue.emit('200 OK');
    let actualMedId = sessionStorage.getItem('medicineId')
    this.router.navigate(['/dashboard/territorial/national', actualMedId]);
  }

  onNationalClick (): void {
    //  if (!this.isDashboardOpen) return;
    //  this.statusTerritorialSidebar=1;
    this.goToNational('Italy');
  }

  onRegionalClick (): void {
    if (!this.isDashboardOpen) return;
    this.showRegioni();
  }


  showModalUserFeedback (value: boolean) {
    this.openFeedbackModal.emit(true);
  }


  toggleSidebar () {
    this.isExpanded = !this.isExpanded;
  }


  navigateToFarmaco () {
    this.statusTerritorialSidebar = 0;
    this.isDashboardOpen = false;
    this.isExpanded = false;

    this.router.navigate(['/dashboard/territorial/farmaco']);
  }


  onNotification () {
    alert('Notifications will be available soon.')
  }


  logout () {
    this.authService.logout();
  }


  toggleProfileDropdown (): void {
    this.isProfileDropdownOpen = !this.isProfileDropdownOpen;
  }

  waitForSidebarContent () {
    setTimeout(() => {
      this.canExpandedConstentShow = true;
    }, 250);
  }

  dashboardOpen = (event: CustomEvent) => {
    this.isDashboardOpen = event.detail;
  };

  whichSolution = (event: CustomEvent) => {
    this.inWhichPage = event.detail;
    this.statusTerritorialSidebar = 1;
    if (this.inWhichPage == "FARMACO" || this.inWhichPage == "NATIONAL" || this.inWhichPage == "REGIONAL") {
      this.isTerritorial = true;
    } else {
      this.isTerritorial = false;
    }
    // console.log("inWhichPage", this.inWhichPage)

  };

  toAvoidClickNationalRegional () {
    this.isDashboardOpen = false;
  }



  // NUOVA SIDEBAR
  arrowOut (event: MouseEvent) {
    if (this.inWhichPage != "NATIONAL" && this.inWhichPage != "REGIONAL") {
      this.navigateToFarmaco();
    }

    if (this.statusTerritorialSidebar === 0) {
      this.statusTerritorialSidebar = 1;
    } else {
      this.setSidebarPosition(event);
    }
  }

  stateofTheArrow (event?: MouseEvent) {
    if (this.statusTerritorialSidebar === 1) {
      // if (event) this.setSidebarPosition(event);
      this.statusTerritorialSidebar = 2;
    } else if (this.statusTerritorialSidebar === 2) {
      this.statusTerritorialSidebar = 1;
    }
  }

  private setSidebarPosition (event: MouseEvent) {
    const buttonRect = (event.target as HTMLElement).getBoundingClientRect();

    if (window.innerWidth < 1280) {
      this.offset = 50;
    }
    if (window.innerWidth >= 1280 && window.innerWidth < 1920) {
      this.offset = 220;
    }

    if (window.innerWidth >= 1920) {
      this.offset = 285;
    }
    this.sidebarPosition = {
      top: buttonRect.bottom - this.offset
    };
  }

  goToHome () {
    this.router.navigate(['/dashboard/home']);
  }

  clickedOutside () {
    this.statusTerritorialSidebar = 1
  }

  private setHospitalSession (data: any[]) {
    const hospital = Array.isArray(data) && data.length > 0 ? data[0] : null;

    const onekey = hospital?.onekey ?? '';
    const name = hospital?.name ?? '';

    sessionStorage.setItem('hospitalOnekey', onekey);
    sessionStorage.setItem('hospitalName', name);

    console.log('hospital:', onekey);
  }

}
